/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
// Default options



document.addEventListener('variant:changed', function(event) {  
   var variant = event.detail.variant; // Gives you access to the whole variant details


  var carousel = document.querySelector('.Carousel');
  var flkty = Flickity.data( carousel );
  // access properties
  //console.log( flkty );
  flkty.selectCell(parseInt(variant.featured_image.position) - 1);                             

});
jQuery('#notify-me').click(function() {
	jQuery('#notify-me-wrapper').fadeIn();

return false;
} );


$('.modal-toggle').on('click', function(e) {
    e.preventDefault();
    $('.modal').toggleClass('is-visible');
});
  
$('nav.SidebarMenu__Nav button.Collapsible__Button').on('click', function(e) {
	hj('event', 'main_menu_open');

});


$(".quickbuy.Mini").hover(
  function() {
  $(this).parent().parent().find('img.Mini').css({"opacity":"1"});
  $(this).parent().parent().find('img.Classic').css({"opacity":"0"});
  $(this).parent().parent().find('img.default').css({"opacity":"0"});
  },function(){}
);
  

$(".quickbuy.Classic").hover(
  function() {
  $(this).parent().parent().find('img.Classic').css({"opacity":"1"});
  $(this).parent().parent().find('img.Mini').css({"opacity":"0"});
  $(this).parent().parent().find('img.default').css({"opacity":"0"});
}, function(){}
);


function isMobile() { return ('ontouchstart' in document.documentElement); }



$(".checkmark").on("click",function(e) {
  console.log("checkmark hit");
  $(this).parent().$("label").get(0).click();
  //('#your_link_id').get(0).click();
  //.SizeSwatchList .HorizontalList__Item 
});
                       
                       
$(".quickbuy").on("click",function(e) {
  
  console.log("logged");
  
  e.preventDefault();
  var targetID = $(this).attr('data-id');
  var targetQT = $(this).attr('data-quantity');
  var bodydata = {
    quantity: targetQT,
      id: targetID
  };
  
  fetch('/cart/add.js', {
    body: JSON.stringify(bodydata),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      // We simply trigger an event so the mini-cart can re-render
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: targetID,
          quantity: targetQT
        }
      }));
    } else {
      response.json().then(function (content) {
        console.log(content);
      });
    }
  });  
  
  
  
});

// Adding iOS 13 fixes from Maestrooo

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();


 (function($){
    $(document).ready(function(e){
      var url = new URL(location.href);
      var params = new URLSearchParams(url.search);
      
      //Iterate the search parameters.
      for (let p of params) {
        console.log(p);
      }
      
      var show_top_flag = params.get('show_top');
      if ( show_top_flag != null ) {  
          // show top two products logic here
          // ... 
      }
});
})(jQuery);


if((typeof ScrollMagic != "undefined"))
{
  if (!isMobile())
  {
    var controller = new ScrollMagic.Controller();
    $(function () { 
      // wait for document ready
      // build scene
      var scene = new ScrollMagic.Scene({triggerElement: ".stickme", offset: 280, duration: 420})
      .setPin(".stickme")
      .addTo(controller);

      var scene = new ScrollMagic.Scene({triggerElement: ".stickme2", offset: 280, duration: 1380})
      .setPin(".stickme2")
      .addTo(controller);  

      var scene = new ScrollMagic.Scene({triggerElement: ".stickme3", offset: 280, duration: 480})
      .setPin(".stickme3")
      .addTo(controller);    

      var scene = new ScrollMagic.Scene({triggerElement: ".stickme4", offset: 280, duration: 1200})
      .setPin(".stickme4")
      .addTo(controller);  

      var scene = new ScrollMagic.Scene({triggerElement: ".stickme5", offset: 280, duration: 1100})
      .setPin(".stickme5")
      .addTo(controller);

      for (var i = 400; i < 3501; i = i+ 50) {
        if ( $( ".stick"+i ).length ) {
          var scene = new ScrollMagic.Scene({triggerElement: ".stick"+i, offset: 280, duration: i})
          .setPin(".stick"+i)
          .addTo(controller);  
        }
      }
    });
  }
}

 